<template>
  <CSectionItem>
    <CItem :title="item.getTitle()" icon="bolt">
      <template #body>
        <CSeparatorBetween>
          <span v-if="item.stockLocation">
            <CIcon name="location-pin"/>
            {{ item.stockLocation.description }}
          </span>

          <span>{{ item.code }}</span>
        </CSeparatorBetween>
      </template>

      <template #right>
        <CStockStatusButton :item v-model="itemFormData.stockStatus" :context class="u-mr-2"/>
        <CPickingStatusButton :item v-model="itemFormData.pickingStatus" :context/>
      </template>
    </CItem>
  </CSectionItem>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CItem from '@/shared/components/CItem.vue';
  import CSeparatorBetween from '@/shared/components/CSeparatorBetween.vue';
  import CSectionItem from '@/shared/components/section/CSectionItem.vue';
  import JobContext from '../../models/JobContext';
  import JobItem from '../../models/JobItem';
  import CPickingStatusButton from '../CPickingStatusButton.vue';
  import CStockStatusButton from '../CStockStatusButton.vue';

  const props = defineProps<{
    item: JobItem;
    context: JobContext;
  }>();

  const formData = defineModel();

  const itemFormData = computed(() => formData.value.items.find(i => i.id === props.item.id));
</script>